import { defineComponent as _defineComponent } from 'vue'
import { __ } from '@@/bits/intl'
import type { Post, WallCustomPostProperty } from '@@/types'
import { computed } from 'vue'

interface PostPropertyDisplayAttributes {
  id: string
  name: string
  value: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePostProperties',
  props: {
    darkMode: { type: Boolean },
    locationName: { default: undefined },
    wallCustomPostProperties: null,
    customPropertyValues: null,
    propertyLabelClass: { default: 'text-body-extra-small' },
    propertyValueClass: { default: 'text-body-small' }
  },
  emits: ["dblclick"],
  setup(__props: any) {

const props = __props as { darkMode: boolean, locationName: string, wallCustomPostProperties: WallCustomPostProperty[], customPropertyValues: Post['custom_properties'], propertyLabelClass: string, propertyValueClass: string }





const customPostProperties = computed<PostPropertyDisplayAttributes[]>(() => {
  return props.wallCustomPostProperties
    .filter((property) => property.id != null)
    .map(
      ({ id, name }) =>
        ({
          id,
          name,
          value: props.customPropertyValues != null ? props.customPropertyValues[id!] : '', // assert TS type for id; we already checked id != null
        } as PostPropertyDisplayAttributes),
    )
    .filter(({ value }) => value != null && value !== '')
})

const postProperties = computed<PostPropertyDisplayAttributes[]>(() => {
  const properties: PostPropertyDisplayAttributes[] = []
  if (props.locationName) {
    properties.push({
      id: 'post-property-location',
      name: __('Location'),
      value: props.locationName,
    })
  }
  properties.push(...customPostProperties.value)
  return properties
})

return { __sfc: true,props, customPostProperties, postProperties }
}

})